'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const Chart = dynamic(() => import('./RevenueChartInner'), { ssr: false });

export default function RevenueChart({ data }: { data: { month: string; revenue: number; invoices: number }[] }) {
  return <Chart data-component-id="src/app/dashboard/components/RevenueChart.tsx:8:9" data-component-path="src/app/dashboard/components/RevenueChart.tsx" data-component-line="8" data-component-end-line="8" data-component-file="RevenueChart.tsx" data-component-name="Chart" data-component-content="%7B%22elementName%22%3A%22Chart%22%7D" data={data} />;
}